import { endpoints } from "../../site/configuration/endpoints";
import { Label, Brand } from "../types";
import { Language } from "../types/";
import { UserInfo } from "../types/";
import { AppInfo } from "../types/System/AppInfo";
import ApiGateway from "./ApiGateway";

export class SystemService {
  // public getLanguages = (): Promise<Language[]> => {
  //   return new Promise<Language[]>((resolve, reject) => {
  //     ApiGateway()
  //       .get<Language[]>(endpoints.system.languages)
  //       .then((result: { data: Language[] | PromiseLike<Language[]> }) =>
  //         resolve(result.data)
  //       )
  //       .catch((error: any) => reject(error));
  //   });
  // };

  public getLabels = (language: string): Promise<Label[]> => {
    return new Promise<Label[]>((resolve, reject) => {
      ApiGateway()
        .get<Label[]>(endpoints.system.labels + "/" + language)
        .then((result: { data: Label[] | PromiseLike<Label[]> }) =>
          resolve(result.data)
        )
        .catch((error: any) => reject(error));
    });
  };

  // public getBrand = (): Promise<Brand[]> => {
  //   return new Promise<Brand[]>((resolve, reject) => {
  //     ApiGateway()
  //       .get<Brand[]>(endpoints.system.brands)
  //       .then((result: { data: Brand[] | PromiseLike<Brand[]> }) =>
  //         resolve(result.data)
  //       )
  //       .catch((error: any) => reject(error));
  //   });
  // };

  public getUserInfo = (): Promise<UserInfo> => {
    return new Promise<UserInfo>((resolve, reject) => {
      ApiGateway()
        .get<UserInfo>(endpoints.system.userinfo)
        .then((result: { data: UserInfo | PromiseLike<UserInfo> }) =>
          resolve(result.data)
        )
        .catch((error: any) => reject(error));
    });
  };

  public getAppInfo = (): Promise<AppInfo> => {
    return new Promise<AppInfo>((resolve, reject) => {
      ApiGateway()
        .get<AppInfo>(endpoints.system.appinfo)
        .then((result) => resolve(result.data))
        .catch((error: any) => reject(error));
    });
  };

  public logout = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      ApiGateway()
        .get<AppInfo>(endpoints.system.logout)
        .catch((error: any) => reject(error));
    });
  };
}
